/* eslint-disable react/display-name */
/*
 * @Author: wangjiaxin@leedarson.com
 * @Date: 2021-10-09 14:16:46
 * Copyright © Leedarson. All rights reserved.
 */
import React, { memo, useState, useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
// import { useOutsideClick } from '@hooks';
// import { observer } from '@helper';
import useOutsideClick from '@root/hooks/useOutsideClick';

const Dropdown = memo(
  ({
    children,
    visible: propsVisible,
    onOpen,
    align,
    origin,
    className = '',
    ...restProps
  }) => {
    const elWrapperRef = useRef();
    const menu = children[0];
    const content = children[1];
    const [visible, setVisible] = useState(false);
    const haveVisibleRef = useRef(false);
    const visibleRef = useRef(visible);
    visibleRef.current = visible;

    const enhancedSetVisible = useCallback((value) => {
      setVisible(value);
      // observer.notify('setNativeTabbarVisible', !value, 'dropdown');
    }, []);

    const prevPropsVisibleRef = useRef(propsVisible);
    useEffect(() => {
      if (propsVisible) {
        haveVisibleRef.current = true;
      }
      if (propsVisible || prevPropsVisibleRef.current !== propsVisible) {
        enhancedSetVisible(propsVisible);
      }
      prevPropsVisibleRef.current = propsVisible;
    }, [enhancedSetVisible, propsVisible]);

    const handleMenuClick = useCallback(() => {
      haveVisibleRef.current = true;
      if (onOpen !== null) {
        onOpen(true);
        return;
      }
      enhancedSetVisible((prevValue) => !prevValue);
    }, [enhancedSetVisible, onOpen]);

    /**
     * 事件：监听deviceList外区域点击
     */
    useOutsideClick(elWrapperRef.current, () => {
      if (visible) {
        if (onOpen !== null) {
          onOpen(false);
          return;
        }
        enhancedSetVisible(false);
      }
    });

    return (
      <div
        className={`dropdown-wrapper lds-dropdown ${className}`}
        {...restProps}
        ref={elWrapperRef}
      >
        {React.cloneElement(menu, { onClick: handleMenuClick })}
        {haveVisibleRef.current ? (
          <>
            {React.cloneElement(content, { visible, align, origin })}
            <div
              className={`dropdown-mask ${visible ? 'visible' : ''}`}
              // visible={visible}
              onClick={() => {
                if (onOpen !== null) {
                  onOpen(false);
                  return;
                }
                enhancedSetVisible(false);
              }}
            />
          </>
        ) : null}
      </div>
    );
  },
);

Dropdown.defaultProps = {
  align: 'left',
  origin: 0,
  children: null,
  visible: false,
  onOpen: null,
};

Dropdown.propTypes = {
  align: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  origin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
  visible: PropTypes.bool,
  onOpen: PropTypes.func,
};

export default Dropdown;
